function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from "react";
import styled from "styled-components";
import { space, color } from "styled-system";
var Svg = styled("svg")({
  flex: "none"
}, space, color);
var SvgCenz = React.forwardRef(function (props, ref) {
  return React.createElement(Svg, _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "currentcolor",
    height: props.size,
    width: props.size,
    ref: ref
  }), React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z",
    fill: "inherit"
  }), React.createElement("path", {
    d: "M16.22 13.409c-.316.272-.6.514-.88.76-.032.027-.063.076-.063.116-.005.479-.003.957-.003 1.451.72-.304 1.097-1.23.946-2.328zm-.868-2.923c.803-.479.898-.644.901-1.594 0-.075.003-.15 0-.223-.035-.873-.632-1.643-1.459-1.827a44.53 44.53 0 00-2.24-.43c-.382-.065-.773-.12-1.158-.107-.466.015-.846.259-1.196.658.849.158 1.637.321 2.43.45 1.09.177 1.922.724 2.377 1.766.176.404.232.862.345 1.307zM8.735 8.23c-.646.4-.963.943-.973 1.618a246.05 246.05 0 00-.005 5.468c.007.882.59 1.64 1.431 1.845.72.175 1.457.283 2.186.424.462.09.92.227 1.396.108.39-.097.738-.262 1.013-.647-.875-.164-1.696-.345-2.525-.468-1.42-.21-2.521-1.468-2.523-2.932-.002-1.675 0-3.348 0-5.022V8.23zm1.003-.263c-.009.185-.022.323-.022.46-.002 1.685-.003 3.37 0 5.054.002 1.107.67 1.902 1.734 2.088.768.135 1.533.285 2.299.428.053.01.107.015.161.02.364.041.377.035.379-.33.004-.559-.015-1.117.011-1.675a.745.745 0 01.21-.478c.608-.543 1.24-1.058 1.863-1.583.17-.142.344-.24.572-.13.24.117.303.318.3.57-.01.633.004 1.267-.015 1.899-.037 1.141-.865 2.265-1.928 2.625a.703.703 0 00-.42.352c-.655 1.163-1.777 1.611-2.979 1.452-.985-.131-1.963-.339-2.937-.547-1.254-.269-2.18-1.436-2.2-2.832-.027-1.88-.018-3.76.014-5.639.02-1.174.893-2.265 2-2.625a.582.582 0 00.295-.243c.743-1.289 1.949-1.812 3.382-1.49.795.177 1.604.294 2.403.457 1.42.29 2.367 1.46 2.386 2.935.006.42.009.839-.015 1.257-.007.132-.065.302-.16.385-.68.6-1.368 1.191-2.074 1.76a.52.52 0 01-.474.042c-.12-.064-.22-.274-.228-.425-.03-.5.026-1.008-.022-1.505-.098-.997-.777-1.655-1.8-1.826-.813-.135-1.624-.281-2.437-.42-.086-.015-.175-.022-.298-.036z",
    fill: "white"
  }));
});
SvgCenz.displayName = "SvgCenz";
SvgCenz.defaultProps = {
  size: 24,
  color: "#3089F2"
};
export default SvgCenz;